(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("MdPage", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["MdPage"] = factory(require("vue"));
	else
		root["MdPage"] = factory(root["Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 